import { useRef, useEffect } from "react";
import { gsap } from "gsap";

export default function StatsCounter() {
    const compRef = useRef(null);
    const countRef1 = useRef(null);
    const countRef2 = useRef(null);
    const countRef3 = useRef(null);

    useEffect(() => {
        let ctx = gsap.context(() => {

            // Fade up the whole section
            gsap.from(".stat-box", {
                scrollTrigger: {
                    trigger: compRef.current,
                    start: "top 85%",
                },
                y: 30,
                opacity: 0,
                stagger: 0.2,
                duration: 0.8,
                ease: "power2.out",
            });

            // Count Up Animations
            const animateCounter = (ref, target) => {
                gsap.to(ref.current, {
                    scrollTrigger: {
                        trigger: compRef.current,
                        start: "top 80%",
                        once: true
                    },
                    innerHTML: target,
                    duration: 3,
                    ease: "power3.out",
                    snap: { innerHTML: 1 },
                });
            };

            animateCounter(countRef1, 15);  // Lata na rynku
            animateCounter(countRef2, 450); // Zrealizowane projekty
            animateCounter(countRef3, 100); // 100% zadowolenia

        }, compRef);
        return () => ctx.revert();
    }, []);

    return (
        <section ref={compRef} className="bg-dark text-background py-20 px-6 border-y border-dark/10 relative overflow-hidden">
            {/* Subtle background noise texture re-applied for dark section */}
            <div className="absolute inset-0 opacity-10 pointer-events-none mix-blend-overlay bg-[url('data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E')]"></div>

            <div className="max-w-7xl mx-auto relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left divide-y md:divide-y-0 md:divide-x divide-background/10">

                    <div className="stat-box flex flex-col items-center md:items-start pt-8 md:pt-0 md:pl-12 first:pl-0 first:pt-0 border-t-0">
                        <div className="flex items-baseline gap-1 text-accent font-heading font-black tracking-tighter text-7xl md:text-8xl mb-2">
                            <span ref={countRef1}>0</span>
                            <span className="text-4xl">+</span>
                        </div>
                        <span className="font-mono text-xs uppercase tracking-widest text-background/60">
                            Lat doświadczenia w rzemiośle
                        </span>
                    </div>

                    <div className="stat-box flex flex-col items-center md:items-start pt-8 md:pt-0 md:pl-12">
                        <div className="flex items-baseline gap-1 text-accent font-heading font-black tracking-tighter text-7xl md:text-8xl mb-2">
                            <span ref={countRef2}>0</span>
                            <span className="text-4xl">+</span>
                        </div>
                            Zrealizowanych projektów na czas
                    </div>

                    <div className="stat-box flex flex-col items-center md:items-start pt-8 md:pt-0 md:pl-12">
                        <div className="flex items-baseline gap-1 text-accent font-heading font-black tracking-tighter text-7xl md:text-8xl mb-2">
                            <span ref={countRef3}>0</span>
                            <span className="text-4xl">%</span>
                        </div>
                        <span className="font-mono text-xs uppercase tracking-widest text-background/60">
                            Pancerna gwarancja satysfakcji
                        </span>
                    </div>

                </div>
            </div>
        </section>
    );
}
